import React, { useState } from "react";
import { Icon } from "@iconify-icon/react";
import { Button } from "../../ui/button";
import { Label } from "../../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import MessageTile from "../../../HelperComponents/MessageTile";
import { requestTaxDocument } from "../../../Service/Services";
import { downloadBlob } from "../../../Utility/Utility";

const MIN_TAX_YEAR = 2015;

const getSelectableTaxYears = (): number[] => {
  const lastCompletedYear = new Date().getFullYear() - 1;
  const years: number[] = [];
  for (let year = lastCompletedYear; year >= MIN_TAX_YEAR; year--) {
    years.push(year);
  }
  return years;
};

const MyW2: React.FC = () => {
  const taxYears = getSelectableTaxYears();
  const [selectedYear, setSelectedYear] = useState<string>(
    taxYears[0]?.toString() ?? "",
  );
  const [isRequesting, setIsRequesting] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState<"success" | "error">(
    "success",
  );

  const handleRequestW2 = async () => {
    const taxYear = Number(selectedYear);
    if (!taxYear) return;

    setIsRequesting(true);
    setMessage("");

    try {
      const { blob, fileName } = await requestTaxDocument(
        { documentType: "W2", taxYear },
        `W2-${taxYear}.pdf`,
      );
      downloadBlob(blob, fileName);
      setMessageType("success");
      setMessage("Your W2 has been downloaded.");
    } catch (error) {
      setMessageType("error");
      setMessage(
        error instanceof Error
          ? error.message
          : "Failed to request your W2. Please try again.",
      );
    } finally {
      setIsRequesting(false);
    }
  };

  return (
    <div className="p-6">
      {message && (
        <MessageTile isVisible={true} message={message} type={messageType} />
      )}

      <div className="flex flex-col gap-4 max-w-sm">
        <div className="flex flex-col gap-2">
          <Label htmlFor="w2-tax-year">Tax Year</Label>
          <Select value={selectedYear} onValueChange={setSelectedYear}>
            <SelectTrigger id="w2-tax-year">
              <SelectValue placeholder="Select a tax year" />
            </SelectTrigger>
            <SelectContent>
              {taxYears.map((year) => (
                <SelectItem key={year} value={year.toString()}>
                  {year}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <Button
          type="button"
          onClick={handleRequestW2}
          disabled={!selectedYear || isRequesting}
        >
          <Icon icon="ion:receipt" />
          {isRequesting ? "Requesting..." : "Request W2"}
        </Button>
      </div>
    </div>
  );
};

export default MyW2;
